module.exports = __webpack_public_path__ + "img/algo.1ed01626.png";